import styled from 'styled-components';
export const RequestInvoiceContainer = styled.div`
    display: flex;
    width: ${({ width }) => (width ? width : '100%')};
    margin: ${({ margin }) => (margin ? margin : '0')};
`;
export const RegularText = styled.div`
    color: ${(props) => (props.color ? props.color : '#585858')};
    font-size: ${(props) => props.fontSize};
    opacity: ${(props) => (props.opacity ? props.opacity : 1)};
    font-family: ${(props) =>
        props.fontFamily ? props.fontFamily : 'AvenirNextWorld Regular'};
    margin: ${({ margin }) => (margin ? margin : 0)};
`;
